import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { setUserName } from './actions';

const nameReducer = handleActions(
  {
    [setUserName.toString()]: (_, { payload: name }) => name
  },
  ''
);

export default combineReducers({
  name: nameReducer
});
